<template>
  <div class="container">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-dialog
      :title="`添加${studentType === 1 ? '临时' : '体验'}学员`"
      :visible.sync="dialogVisible"
      :width="`${studentType === 1 ? '800px' : '675px'}`"
      append-to-body
      destroy-on-close
      @submit.native.prevent
    >
      <el-form size="mini" :model="searchInfo" inline @submit.native.prevent>
        <el-form-item label="学员搜索：" prop="name">
          <el-input
            v-model="searchInfo.key_word"
            placeholder="学员姓名/手机号"
            @change="handleSearch"
            prefix-icon="el-icon-search"
            clearable
            maxlength="30"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="alreadChoose">
        <div class="chooseTitle">已选学员:</div>
        <div class="chooseInfo">
          <div class="alreadChooseText">
            已选择<span> {{ selected.length }} </span>人
          </div>
          <div class="alreadChooseSpan">
            <span class="name" v-for="(item, index) in selected" :key="index">
              {{ item.name }}
              <!-- <i class="iconfont icon-sousuo-03" @click="delSelcted(item)"></i> -->
            </span>
          </div>
        </div>
      </div>
      <el-table
        size="mini"
        :data="tableData"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        height="300"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column label="学员姓名">
          <template slot-scope="scope">
            <div class="mwow-gray" v-if="scope.row.is_del === 1">
              {{ scope.row.name || "-" }}
              <span class="mwow-tag del-filled large">已删除</span>
            </div>
            <div class="mwow-green" v-else>
              {{ scope.row.name || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex" v-if="studentType === 1">
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 0">-</span>
            <span v-if="scope.row.sex === 1">男</span>
            <span v-if="scope.row.sex === 2">女</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="mobile"
          width="100"
        ></el-table-column>
        <el-table-column
          label="排课课程"
          prop="course_list"
          v-if="studentType === 1"
          width="240"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.chooseItemCid"
              placeholder="请选择"
              @change="chooseCourse($event, scope.row)"
            >
              <el-option
                v-for="item in scope.row.course_list"
                :key="item.course_id"
                :label="item.title"
                :value="item.course_id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="剩余课时" v-if="studentType === 1" width="150">
          <template slot-scope="scope">
            <span style="margin-right: 5px">{{
              scope.row.chooseItem.account.usable_number
            }}</span>
            <span
              v-if="scope.row.chooseItem.account.expire_status == 1"
              class="mwow-red"
              style="margin-right: 5px"
              >(已过期)</span
            >
            <span
              v-if="scope.row.chooseItem.account.stop_status == 2"
              class="mwow-red"
              style="margin-right: 5px"
              >(已停课)</span
            >
            <span
              v-if="Number(scope.row.chooseItem.account.exceed_number) != 0"
              class="mwow-red"
              >(超上{{ scope.row.chooseItem.account.exceed_number }}课时)</span
            >
          </template>
        </el-table-column>
        <el-table-column label="学员状态" v-if="studentType === 5">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1" class="mwow-yellow">意向</span>
            <span v-if="scope.row.status === 2" class="mwow-green">在读</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="footer">
        <p class="total"></p>
        <div class="btns">
          <div class="mwow-button-filled mini" @click="hideDialog">取消</div>
          <div class="mwow-button-filled mini success" @click="handleSubmit">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import conflictDialog from "@/view/teachManagement/classManagement/classDetail/log/conflictDialog.vue";
import { lessonStudentConflictCheckApi } from "@/api/classSchedule";
import { getStudentSelectList, studentExperience } from "@/api/classManagement";
import { addLessonStudent } from "@/api/lesson";

export default {
  components: {
    conflictDialog,
  },
  // @Prop() lessonData!: any;
  // @Prop() studentType!: number;
  props: ["lessonData", "studentType"],
  data() {
    return {
      searchInfo: {},
      selected: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      dialogVisible: false,
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.selected = [];
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    delSelcted(item) {
      const _t = this;
      _t.$refs.multipleTable.toggleRowSelection(item);
    },
    getList(params) {
      if (this.studentType === 1) {
        //临时
        if (this.searchInfo.key_word) {
          params.key_word = this.searchInfo.key_word;
        }
        params.original_class_id = this.lessonData.class_id;
        params.lesson_id = this.lessonData.lesson_id;
        getStudentSelectList(params).then((res) => {
          if (res.error_code === 0) {
            if (res.data.list.length > 0) {
              res.data.list.map((a) => {
                a.chooseItemCid = a.course_list[0].course_id;
                a.chooseItem = a.course_list[0];
              });
            }
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.page = params.page;
          }
        });
      } else {
        //体验
        if (this.searchInfo.key_word) {
          params.key_word = this.searchInfo.key_word;
        }
        params.lesson_id = this.lessonData.lesson_id;
        studentExperience(params).then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        });
      }
    },
    chooseCourse(e, item) {
      item.course_list.map((a) => {
        if (a.course_id == e) {
          item.chooseItem = a;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSelectionChange(arr) {
      this.selected = arr;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      if (this.selected.length === 0) {
        this.$message({
          type: "error",
          message: "请先选择学员",
        });
        return false;
      }
      this.handleCheckConflict();
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleCheckConflict() {
      lessonStudentConflictCheckApi({
        lesson_id: this.lessonData.lesson_id,
        student_ids: this.selected.map((item) => {
          return item.student_id;
        }),
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      const option = {
        lesson_id: this.lessonData.lesson_id,
        student_type: this.studentType,
        in_roll_call: false,
      };
      const arr = [];
      this.selected.map((item) => {
        let course_id = 0;
        if (this.studentType === 1) {
          course_id = item.chooseItemCid ? item.chooseItemCid : 0;
        } else {
          course_id = this.lessonData.course_id;
        }
        arr.push({
          student_id: item.student_id,
          course_id: course_id,
        });
      });
      option.student_list = arr;
      addLessonStudent(option).then((res) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.hideDialog();
          this.$emit("change");
        } else {
          this.$message({
            type: "error",
            message: "添加失败!" + res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: inline-block;
  margin-left: 10px;
}
.pagination-wrap {
  overflow: hidden;
}
.alreadChoose {
  display: flex;
  .chooseTitle {
    font-size: 12px;
    color: #5c5d5e;
    width: 75px;
  }
  .alreadChooseText {
    font-size: 12px;
    color: #5c5d5e;
    span {
      color: #07d1aa;
    }
  }
  .chooseInfo {
    flex: 1;
  }
  .alreadChooseSpan {
    margin: 14px 0;
    .name {
      color: #07d1aa;
      display: inline-block;
      line-height: normal;
      position: relative;
      padding: 8px 10px 8px 10px;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      margin-right: 4px;
      margin-bottom: 4px;
      i {
        color: #fff;
        font-size: 10px;
        width: 15px;
        height: 15px;
        background: #d8d8d8;
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        line-height: 16px;
        cursor: pointer;
      }
    }
  }
}
.footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  display: flex;
  padding: 20px 20px 0 20px;
  align-items: center;
  .total {
    flex: 1;
    font-size: 14px;
    color: #5c5d5e;
  }
  .btns {
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
